var React = require('react');

function ConstructionHelmet48px (props) {
    return React.createElement("symbol",props,React.createElement("path",{"d":"M8.8 36.5c-2.9 0-6.5-.2-7.9-1a1.8 1.8 0 0 1-.9-1.6 2 2 0 0 1 1.2-1.6c0-2.4.3-9.1 4-14.6l.3-.3c4.2-6 13.5-6.7 13.9-6.7 12-.7 17.9 8.9 18.1 9.3a27.3 27.3 0 0 1 2.2 7.6 3.6 3.6 0 0 0 .5 1.7h.5c4.7 1.2 6.6 2 7.1 3a1.4 1.4 0 0 1 .1 1.1h-.1a4.5 4.5 0 0 1-4.4 2.1l-2.1-.2a78.9 78.9 0 0 0-8.7-.5c-3.4.1-20 1.2-20.2 1.2zm-6.4-2.6c1.9.6 6.7.6 10 .4.7 0 16.8-1.1 20.3-1.2a82.9 82.9 0 0 1 8.9.5l2 .2a2.7 2.7 0 0 0 2.1-.7 25.3 25.3 0 0 0-5.5-1.8h-.6c-1.6-.4-1.9-2.7-1.9-3.4a25.9 25.9 0 0 0-2-6.9 18.3 18.3 0 0 0-16.3-8.2c-.1 0-8.9.6-12.5 6l-.2.3c-3.6 5.6-3.6 12.5-3.5 13.8a1 1 0 0 1-.6 1zm37.8-4.6z"}));
}

ConstructionHelmet48px.displayName = "ConstructionHelmet48px";

ConstructionHelmet48px.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = ConstructionHelmet48px;

ConstructionHelmet48px.default = ConstructionHelmet48px;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/48px/construction-helmet-48px.svg
// module id = 1133
// module chunks = 0